<template>
    <mymodal ref="modal" title="Множественное присвоение кода" ok="Применить" :reset="reset" :check="check" :submit="submit">
		<div class="rules_many-edit">
			<b-form-input v-model="code" placeholder="Введите код..." type="number" :state="state"/>
			<b-form-invalid-feedback :state="state" tooltip>
				Целое положительное число
			</b-form-invalid-feedback>
		</div>
    </mymodal>
</template>

<script>
import mymodal from '../../../widgets/modal'

export default {

	props :
	{
		rules : Array
	},

    components :
    {
        mymodal
    },

    data()
    {
        return {
            code : null,
			state : null
        }
    },

    methods :
    {
        execute()
        {
            this.$refs.modal.execute()
        },

		check()
		{
			const notEmpty = this.code !== null && this.code !== undefined && this.code !== ""

			if (notEmpty)
			{
				this.state = this.code >= 0 && !this.code.toString().includes(".")
			}
			else
			{
				this.state = null
			}

			return notEmpty && this.state
		},

        submit()
        {
			if(this.rules.findIndex(rule => rule.code == this.code) >= 0)
			{
				const h = this.$createElement

				const content =
					h("div",
					[
						h("p", {}, "Существуют значения с присвоеным кодом. Таким значениям будет присвоен новый код."),
						h("p", {}, "Продолжить?"),
					])

				return this.$bvModal.msgBoxConfirm(content,
				{
					id : "modal_window",
					title : "Предупреждение",
					okTitle : "Продолжить",
					cancelTitle : "Отменить",
					cancelVariant : "outline-primary-secondary",
					hideHeaderClose : false,
					centered : true
				})
				.then(value =>
					{
						if(value)
							this.$emit("set_code", this.code)

						return value
					}
				)
			}
			else
				this.$emit("set_code", this.code)
        },

        reset()
        {
            this.code = null
        }
    }
}
</script>

<style scoped>
.rules_many-edit
{
    position: relative;
}

.rules_many-edit .invalid-tooltip
{
    display: none !important;
    top: 1.625rem;
    left: unset;
    right: .5rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.rules_many-edit .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block !important;
}

.rules_many-edit:has(.form-control.is-invalid)
{
	height: 3.75rem;
}
</style>
